import { INFINITE_PLAN } from '../../utils/constants';
export const CATOGORY_SECURITY = 'SEGURANCA';
export const CATOGORY_COMFORT = 'CONFORTO';
export const CATOGORY_SOUND = 'SOM';
export const CATOGORY_SEATS = 'BANCOS';
export const CATOGORY_WINDOWS = 'JANELAS';
export const CATOGORY_OTHER = 'OUTROS';

export const KEYCLOAK_PATH = process.env.REACT_APP_KEYCLOAK;
export const isInfinitePlan = id => id === INFINITE_PLAN;
